// extracted by mini-css-extract-plugin
module.exports = {"initialLoading":"maxWidth__initialLoading2ZQ","max":"maxWidth__max3ua"};